import request from '@/utils/request'

const key = 'storeAccount'

// 查询账号列表
export function fetchStoreAccountList(params) {
  return request({
    url: `/platform/${key}`,
    method: 'get',
    params: {
      ...params
    }
  })
}

// 新增账号
export function createStoreAccount(data) {
  return request({
    url: `/platform/${key}`,
    method: 'post',
    data
  })
}

// 编辑账号
export function updateStoreAccount(id, data) {
  return request({
    url: `/platform/${key}/${id}`,
    method: 'post',
    data
  })
}

// 重置密码
export function editAccountPsw(id, data) {
  return request({
    url: `/platform/${key}/password/${id}`,
    method: 'post',
    data
  })
}

// 批量禁用/启用
export function updateMultiStatus(data) {
  return request({
    url: `/platform/${key}/status`,
    method: 'post',
    data
  })
}
